import { PlessViewUtils } from '../../shared/utils/pless-view-utils.service';
import { isArray } from 'util';
import * as Encoding from 'encoding-japanese';

/**
 * 表示に関する便利機能を提供するUtilの拡張クラス
 */
export class PlessViewUtilsSub extends PlessViewUtils {

  /**
   * 文字列の空白,タブ,改行を置換し、trimを実施
   *
   * @static
   * @param {string} value トリム文字列
   * @returns {string} 変換後文字列
   * @memberof PlessViewUtils
   */
  static trim(value: string): string {
    if (this.isEmpty(value)) {
      return value;
    }

    value = String(value).replace(/^(　| |\t|\n|\r|\0|\x0B)*/g, '');
    value = String(value).replace(/(　| |\t|\n|\r|\0|\x0B)*$/g, '');

    return value;
  }

  /**
   * 数値の先頭にゼロ詰めを行って、指定した長さの文字列にします。
   * 指定された数値の長さがすでに指定した桁数以上の場合は、そのまま文字列に変換して返します。
   *
   * @static
   * @param {number} numberArg
   * @param {string} source
   * @returns 結果の文字列
   * @memberof PlessViewUtilsSub
   */
  static zeroPadding(numberArg: number, source: string) {
    let str: string = <string>'';
    for (let i: number = <number>0; i < numberArg - source.length; i++) {
      str += '0';
    }
    return str + source;
  }

  /**
   * 文字列のパディング
   *
   * @static
   * @param {string} [text=''] 桁揃えしたい対象の文字列式
   * @param {number} [len=0] 文字列の長さ
   * @param {string} [ins=' '] 付加したい文字列式
   * @param {number} [direction='1'] 付加する方向(1：左に付加して桁揃え、2：右に付加して桁揃え)
   * @returns
   * @memberof PlessViewUtilsSub
   */
  static padding(text = '', len = 0, ins = ' ', direction = 1) {
    let result: string = text;

    for (let i: number = text.length; i < len; i++) {
      if (direction === 1) {
        // 左に付加
        result = ins + result;
      } else {
        // 右に付加
        result = result + ins;
      }
    }

    // 編集後文字列を返却
    return result;
  }

  /**
   * 引数で渡ってきた文字列の情報をBoolean型に変換します。
   * 注意：'0'以外はtrueと判断される為、使用目的を明確にする必要があります。
   *
   * @static
   * @param {string} source
   * @returns
   * @memberof PlessViewUtilsSub
   */
  static StringTOBoolean(source: string): boolean {
    if (source === '0') {
      return false;
    } else {
      return true;
    }
  }

  /**
   * bool値を示す文字列をbooleanに変換する。
   *
   * @static
   * @param {string} source
   * @returns
   * @memberof PlessViewUtilsSub
   */
  static StringBooleanTOBoolean(source: string): boolean {
    if (source.toLowerCase() === 'true') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 引数で渡ってきた文字列の情報をBoolean型に変換します。
   * 注意：'1'以外はfalseと判断される為、使用目的を明確にする必要があります。
   *
   * @static
   * @param {string} value 変換対象文字列
   * @returns {boolean}
   * @memberof PlessViewUtilsSub
   */
  // 項番2231 START 障害管理NO.I00556対応
  static convStringToBoolean(value: string): boolean {
    let ret = Boolean(false);

    if (!this.isEmpty(value) && value === '1') {
      ret = true;
    }

    return ret;
  }
  // 項番2231 END   障害管理NO.I00556対応

  /**
   * 指定の文字列へのカンマの追加、削除を行う。
   *
   * @param {string|number} text 編集対象文字列
   * @param {boolean} flag 編集フラグ(true：カンマを追加、false：カンマを削除)
   * @returns 編集後文字列
   */
  static editPriceComma(text: string|number, flag: boolean): string {

    if ('number' === typeof text) {
      text = '' + text;
    }

    // 編集対象文字列のチェック
    if (this.isEmpty(text) === false) {                                         // 指定ありの場合
      // 編集フラグのチェック
      if (flag === true) {                                                      // 「true：カンマを追加」の場合
        // マイナス判定
        const isMinus = String(text).startsWith('-');

        // 小数以下を退避
        const array: Array<string> = String(text).split('.');

        // 編集対象文字列にカンマを追加
        text = String(array[0]).replace(/,/g, '');                              // カンマ削除
        text = Number(text).toString();                                         // 数値化
        text = String(text).replace(/\B(?=(\d{3})+(?!\d))/g, ',');              // カンマ追加

        // 小数以下のチェック
        if (array.length > 1) {                                                 // 小数以下がある場合
          // 小数以下を再度付与
          text = text + '.' + array[1];
        }
        // マイナスチェック
        if (isMinus && !text.startsWith('-')) {
          text = '-' + text;
        }
      } else {                                                                  // 上記以外(false：カンマを削除)の場合
        // 編集対象文字列のカンマを削除
        text = String(text).replace(/,/g, '');                                  // カンマ削除
        text = Number(text).toString();                                         // 数値化
      }
    }

    // 編集後文字列を返却
    return text;
  }

  /**
   * 指定の文字列のパーセント編集を行う。
   *
   * @param {string|number} text 編集対象文字列
   * @returns 編集後文字列
   */
  static editPercent(text: string|number): string {

    if ('number' === typeof text) {
      text = '' + text;
    }
    
    // 編集対象文字列のチェック
    if (this.isEmpty(text) === false) {                                         // 指定ありの場合

      // カンマの追加
      text = this.editPriceComma(text, <boolean>true);

      // 末尾にパーセント記号を追加
      text = text + '%';
    }

    // 編集後文字列を返却
    return text;
  }

  /**
   * 指定の文字列のトリム処理を行う。
   *
   * @param {string} text 編集対象文字列
   * @param {number} flag トリム方向フラグ(0：前方＋後方、1：後方、2：前方)
   * @returns 編集後文字列
   */
  static trimDirection(text: string, flag = 0): string {

    // トリムフラグのチェック
    if (flag === 1) {                                                           // 「1：後方」の場合
      // トリム処理
      text = text.replace(/(　| |\t|\n|\r|\0|\x0B)*$/, '');                     // 後方のトリム処理
    } else if (flag === 2) {                                                    // 「2：前方」の場合
      // トリム処理
      text = text.replace(/^(　| |\t|\n|\r|\0|\x0B)*/, '');                     // 前方のトリム処理
    } else {                                                                    // 上記以外(0：前方＋後方)の場合
      // トリム処理
      text = text.replace(/^(　| |\t|\n|\r|\0|\x0B)*/, '');                     // 前方のトリム処理
      text = text.replace(/(　| |\t|\n|\r|\0|\x0B)*$/, '');                     // 後方のトリム処理
    }

    // 編集後文字列を返却
    return text;
  }

  /**
   * Booleanを文字に変換する
   * 例)false => 0, true => 1
   */
  static booleanTOString(flg: boolean): string {
    if (flg) {
      return '1';
    } else {
      return '0';
    }
  }

  /**
   * 指定の文字列の日付編集を行う。
   *
   * @param {string} text 編集対象文字列
   * @param {string} pattarn パターン番号
   *    1：2009/01/01　→　20090101
   *    2：20090101　→　2009/01/01
   *    3：2009/01/01 20:26:24　→　2009年01月01日 20:26:24
   *    4：0101　→　01/01
   *
   * @returns 編集後文字列
   */
  static editDate(text: string, pattarn: string): string {
    // 編集対象文字列のチェック
    if (this.isEmpty(text)) {                                                   // 指定なしの場合
      // 処理復帰
      return this.nullToBlank(text);
    }

    let result: string = <string>'';

    // パターン番号のチェック
    switch (pattarn) {
      case '1':                                                                 // 「1：2009/01/01　→　20090101」の場合
        result = text.replace(/\u002f/g, '');
        break;

      case '2':                                                                 // 「2：20090101　→　2009/01/01」の場合
        result = text.substr(0, 4) + '/' + text.substr(4, 2) + '/' + text.substr(6, 2);
        break;

      case '3':                                                                 // 「3：2009/01/01 20:26:24　→　2009年01月01日 20:26:24」の場合
        result = text.substring(0, 4) + '年' + text.substring(5, 7) + '月' + text.substring(8, 10) + '日' + ' ' + text.substring(11);
        break;

      case '4':                                                                 // 「4：0101　→　01/01」の場合
        result = text.substring(0, 2) + '/' + text.substring(2, 4);
        break;

      default:                                                                 // 上記以外の場合
        result = text;
        break;
    }

    // 編集後文字列を返却
    return result;
  }

  /**
   * 末尾ゼロサプレス
   * 指定した桁数まで小数点以下の"０”を削除する。
   * ゼロ以外の数値が検出した場合は、その時点での編集結果を返却する。
   *
   * @static
   * @param {string} text 編集対象文字列
   * @param {number} len 最大小数点以下桁数
   * @returns {string} 編集後文字列
   * @memberof PlessViewUtilsSub
   */
  static trailingZeroSuppress(text: string, maxLen: number): string {
    // カンマ編集(削除)
    text = this.editPriceComma(text, false);

    // 小数点出現インデックスを取得
    const pointIndex: number = text.indexOf('.', 0);

    // 小数点の有無チェック
    if (pointIndex === -1) {                                                    // 小数点なし
      // 編集後文字列を返却
      return text;
    }

    // 最終桁数(小数点出現インデックス + 最大小数点以下桁数)を算出
    const finIndex: number = pointIndex + maxLen;

    let cutLen = Number(0);                                             // カット文字数

    // カット文字数を算出
    for (let i: number = text.length - 1; i > finIndex; i--) {                  // 文字列の末尾から最終桁数までループ

      // 文字のチェック
      if ('0' === text.charAt(i)) {                                             // ゼロの場合

        // カット文字数を加算
        cutLen++;

        // 文字のチェック
        if ('.' === text.charAt(i - 1)) {                                       // 小数点の場合
          // カット文字数を加算
          cutLen++;

          // ループ中断
          break;
        }
      } else {                                                                  // 上記以外の場合
        // ループ中断
        break;
      }
    }

    // 編集後文字列を返却
    return text.substring(0, text.length - cutLen);
  }

  /**
   * リスト・文字列変換
   * 指定の編集対象文字列リストの要素を指定の区切り文字で連結した結果の文字列を返却する。
   *
   * @static
   * @param {Array<string>} array 編集対象文字列リスト
   * @param {string} delim 区切り文字
   * @returns {string} 編集後文字列
   * @memberof PlessViewUtilsSub
   */
  static arrayToString(array: Array<string>, delim: string): string {
    let result: string = <string>'';

    // 編集対象文字列リストのチェック
    if (array === null) {                                                       // NULLの場合
      // 編集後文字列を返却
      return result;
    }

    // リスト・文字列変換処理
    for (let i = Number(0); i < array.length; i++) {                   // リスト要素数分ループ
      // ループインデックスのチェック
      if (i === 0) {                                                            // ゼロの場合
        // リスト・文字列変換処理
        result = array[i];
      } else {                                                                  // 上記以外の場合
        // リスト・文字列変換処理
        result = result + delim + array[i];
      }
    }

    // 編集後文字列を返却
    return result;
  }

  /**
   * リストサイズ調整
   * 指定の編集対象リストの要素を指定のサイズまでに削除したリストを返却する。
   *
   * @static
   * @param {Array<any>} array 編集対象リスト
   * @param {number} len 編集後リストサイズ
   * @returns {Array<any>} 編集後リスト
   * @memberof PlessViewUtilsSub
   */
  static formatList(array: Array<any>, size: number): Array<any> {
    const newArray: Array<any> = new Array<any>();

    // リストのサイズと指定のサイズの比較
    if (array.length > size) {                                                  // リストのサイズが小さい場合
      // 編集後リストに追加
      for (let i = Number(0); i < size; i++) {                         // リスト要素数分ループ
        // 編集後リストに追加
        newArray.push(array[i]);
      }

      // 編集後リストを返却
      return newArray;
    } else {                                                                    // 上記以外の場合
      // 編集対象リストを無編集で返却
      return array;
    }
  }

  /**
   * Ｐコード形式判定
   *
   * @static
   * @param {string} text 判定対象文字列
   * @returns {boolean} 判定結果(true：正常、false：異常)
   * @memberof PlessViewUtilsSub
   */
  static validatePCode(text: string): boolean {
    const result: RegExpMatchArray = text.match(/^P\d{7}$/);

    if (result !== null) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * JANコード形式判定
   *
   * @static
   * @param {string} text 判定対象文字列
   * @returns {boolean} 判定結果(true：正常、false：異常)
   * @memberof PlessViewUtilsSub
   */
  static validateJanCode(text: string): boolean {
    // 入力有無のチェック
    if (!this.isEmpty(text)) {                                                  // 入力ありの場合

      // 整数値チェック
      if (!this.isIntString(text)) {                                            // 整数値ではない場合
        return Boolean(false);
      }
      // 桁数チェック
      if (text.length !== 8 && text.length !== 13) {                            // 8桁以外、13桁以外の場合
        return Boolean(false);
      }

      // JANコードチェックディジット判定
      if (!this.checkJanCodeCheckDigit(text)) {                                 // 不適切な場合
        return Boolean(false);
      }
    }

    return Boolean(true);
  }

  /**
   * 整数値判定
   *
   * @static
   * @param {string} text 判定対象文字列
   * @returns {boolean} 判定結果(true：正常、false：異常)
   * @memberof PlessViewUtilsSub
   */
  static isIntString(text: string): boolean {
    let result = Boolean(false);
    const num = Number(text);

    // 数値チェック
    if (isNaN(num)) {                                                           // 数値ではない場合
      // 文字列
      result = Boolean(false);
    } else {                                                                    // 数値の場合
      // カンマで文字列分割
      const numArray: Array<string> = String(text).split('.');

      // 配列要素数のチェック
      if (numArray.length > 1) {                                                // 複数の場合(小数点を含む)
        // 小数値
        result = Boolean(false);
      } else {                                                                  // 単一の場合(小数点を含まない)
        // 整数値
        result = Boolean(true);
      }
    }

    // 判定結果を返却
    return result;
  }

  /**
   * JANコードチェックディジットの確認
   *
   * @static
   * @param {string} text 判定対象JANコード
   * @returns {boolean} 判定結果(true：正常、false：異常)
   * @memberof PlessViewUtilsSub
   */
  static checkJanCodeCheckDigit(text: string): boolean {
    let result = Boolean(true);
    let code: string = null;

    // 13桁にパディングする(先頭0埋め）
    code = this.padding(text, 13, '0', 1);

    // 検証用JANコード(12桁)
    const codeValue: string = code.substring(0, code.length - 1);

    // 検証用チェックデジット
    const inputCode: string = code.substring(code.length - 1);

    // 比較用チェックデジット(検証用JANコードから生成する)
    const createCode: string = this.getModulus103W1(codeValue);

    // チェックデジットの比較
    if (inputCode !== createCode) {                                             // 異なる場合
      result = Boolean(false);
    }

    // 判定結果を返却
    return result;
  }

  /**
   * モジュラス10ウエイト3-1のチェックディジットを生成する
   *
   * @static
   * @param {string} text 対象文字列
   * @returns {string}
   * @memberof PlessViewUtilsSub
   */
  static getModulus103W1(text: string): string {
    let result = String('');                                            // チェックディジット
    let even = Number(0);                                               // 偶数の合計
    let odd = Number(0);                                                // 奇数の合計
    let sum = Number(0);                                                // 総計
    let c: string = null;
    let y: number = null;

    // 空文字でないことを確認
    if (!this.isEmpty(text)) {
      for (let i: number = text.length - 1; i >= 0; i--) {
        c = text.charAt(i);
        y = Number(c);

        // 右端を2桁目として、偶数桁と奇数桁の各合計を求める
        if ((text.length - i + 1) % 2 === 0) {
          even = even + y;
        } else {
          odd = odd + y;
        }
      }

      sum = even * 3 + odd;

      switch (sum % 10) {
        case 0:
          // 総和の1桁目（=10での剰余）が0の場合、チェックディジットは0
          result = '0';
          break;

        default:
          // 上記以外の場合、10から総和の1桁目を引いた値をチェックディジットとする
          sum = 10 - sum % 10;
          result = sum.toString();
          break;
      }
    }

    return result;
  }

  /**
   * 日付・文字列変換
   * 指定の日時を指定フォーマットの文字列に変換した結果を返却する。
   *
   * @static
   * @param {Date} date 編集対象日付
   * @param {string} [format='YYYY/MM/DD'] 編集対象フォーマット(YYYY:年 MM:月 DD:日 hh:時 mm:分 ss:秒)
   * @returns {string} 編集後文字列
   * @memberof PlessViewUtilsSub
   */
  static dateToString(date: Date, format = 'YYYY/MM/DD'): string {
    let result: string = format;
    result = result.replace(/YYYY/g, date.getFullYear().toString());
    result = result.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    result = result.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    result = result.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    result = result.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    result = result.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));

    // 編集後文字列を返却
    return result;
  }

  /**
   * 複製した配列を取得する
   * ※要素が配列の場合は0番目を使用する
   *
   * @param {Array<any>} src
   * @returns {Array<any>}
   * @memberof KYMW9001Model
   */
  static getCloneArray(src: Array<any>): Array<any> {
    // 返却用のArray
    const dest: Array<any> = new Array<any>();

    for (const item of src) {
      const obj: any = new Object;
      for (const key of Object.keys(item)) {
        if (isArray(item[key])) {
          obj[key] = item[key][0];
        } else {
          obj[key] = item[key];
        }
      }
      dest.push(obj);
    }

    return dest;
  }


  // 項番2231 START 障害管理NO.U01024対応
  /**
   * 選択されたファイルの拡張子を取得(すべて小文字で返す)
   * @param fileName ファイル名
   */
  static getExtension(fileName: string) {
    let ret;
    if (!fileName) {
      return ret;
    }
    const fileTypes = fileName.split('.');
    const len = fileTypes.length;
    if (len === 0) {
      return ret;
    }
    ret = fileTypes[len - 1].toLowerCase();
    return ret;
  }
  // 項番2231 END 障害管理NO.U01024対応

  /**
   * 日付の形式であるかどうかチェック
   * @param dateString 
   * @returns 
   */
  static isValidDate(dateString: string, regex: RegExp = /^\d{4}\d{2}\d{2}$/) {
    // 日付フォーマットが "YYYY-MM-DD" であるかを確認
    if (!regex.test(dateString)) {
      return false; // フォーマットが違う場合
    }  
    const date = new Date(dateString);
    return date instanceof Date;
  }


  // 禁則文字
  public static readonly REGEX_SPECIAL_CHARA = /('|"|&|<|>|\\)+/;
  // Pコード 正規表現
  public static readonly PCODE_REGEX = /^P[0-9]{7}$/;

  /**
   * 画面表示用にコードと名称を:繋ぎの文字列に変換する
   * コードもしくは名称がない場合は:を付与しない
   * @param code
   * @param name
   * @returns 
   */
  static toDisplayCodeAndName(code: string, name: string): string {
    if (!this.isEmpty(code) && !this.isEmpty(name)) {
      return code + ':' + name;
    } else {
      return code + name;
    }
  }

  /**
   * 半角英数字を全角に変換する
   * @param str
   * @returns 
   */
  static toFullWidth(str: string) {
    // 半角英数字を全角に変換
    return str.replace(/[A-Za-z0-9]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
    })
  }

  /**
   * 全角英数字を半角に変換する
   */
  static toHalfWidth(str: string) {
    // 全角英数字を半角に変換
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }

  /**
   * 入力制限（wj-auto-completeなどinputを動的に生成する項目用）
   * [restrict]="true"での処理。
   * PlessInputTextSubDirectiveで定義されている処理から抜き出し。
   * 
   * @param value 対象文字列
   * @param allowMultiLine 改行を許容するか否か（デフォルトはfalse）
   */
  static doInputRestrict(value: string, allowMultiLine: boolean = false): string {
    const restrict = "[ -￮]";
    let resultValue = "";
    let valueArray = `${value}`.split('');

    // 改行文字を除去する
    if (!allowMultiLine) {
      let reqValue = value.replace(/^(\n|\r|\0|\x0B)*/gm, '').replace(/(\n|\r|\0|\x0B)*$/gm, '');
      reqValue = reqValue.replace(/(\n|\r|\0|\x0B)*/gm, '');
      reqValue = reqValue.replace('\r', '');
      reqValue = reqValue.replace('\n', '');

      resultValue = reqValue;
    }

    valueArray = `${resultValue}`.split('');
    resultValue = "";
    for (let i = Number(0); i < valueArray.length; i++) {
      // 正規表現チェック
      if (valueArray[i].match(restrict)) {
        // 入力可能文字だけ残す
        resultValue += valueArray[i];
      }
    }

    // Shift-jis 範囲で無い文字は、削除する。
    //  第１水準、第２水準のみ許可する。第３水準は許可しない。
    valueArray = `${resultValue}`.split('');
    resultValue = ''
    for (let i = 0; i < valueArray.length; i++) {
      const kanjiSJIS = Encoding.convert(valueArray[i], 'SJIS', 'AUTO');
      const kanjiSJIScode = Encoding.stringToCode(kanjiSJIS);
      if (!(kanjiSJIS === '?' && valueArray[i] !== '?')) {                       // SJIS 変換可能文字の場合
        if (kanjiSJIScode.length === 2) {                // 2bytes系文字のみ入力可能とする。
          // 文字コードの範囲チェックを行い、範囲内のみ入力可能とする。
          // チェック1 1byte目 81xx～9Fxx または、E0xx～FCxx のみ入力可能範囲チェック
          if ((kanjiSJIScode[0] >= 129 &&              // 1byte目 81xx～9Fxx または、E0xx～EAxx のみ入力可能
              kanjiSJIScode[0] <= 159) ||         // 129 = 0x81 ,  159 = 0x9F
              (kanjiSJIScode[0] >= 224 &&              // 224 = 0xE0 ,  252 = 0XFC
              kanjiSJIScode[0] <= 252)) {

            // チェック2 2byte目 xxは、40～7E または 80～FC のみ入力可能範囲チェック
            if ((kanjiSJIScode[1] >= 64 &&             // 2byte目 xxは、40～7E または 80～FC のみ入力可能
                kanjiSJIScode[1] <= 126) ||       //  64 = 0x40 ,  126 = 0x7E
                (kanjiSJIScode[1] >= 128 &&            // 128 = 0x80 ,  252 = 0xFC
                kanjiSJIScode[1] <= 252)) {

              resultValue += valueArray[i];        //入力可能文字のみ応答用に保存する
            }
          }
        } else if (kanjiSJIScode.length === 1) {        // 1バイト系文字は、入力可
          resultValue += valueArray[i];                 //入力可能文字のみ応答用に保存する
        }
      }
    }

    return resultValue;
  }
}
